import { useState, useRef, useEffect, useContext, useCallback } from 'react';
import { useLocation, useHistory, useParams } from 'react-router-dom';
import {
  Button,
  ContentCard,
  Input,
  Label,
  SelectGeneric,
  Switch
} from 'ypf-pas-general-ui-components';
import { Form, Formik } from 'formik';
import { Col } from 'react-bootstrap';
import { AiOutlinePlusCircle } from 'react-icons/ai';

import FooterButtonTemplate from '../../../components/FooterButtonTemplate/FooterButtonTemplate';
import MainTitle from '../../../components/MainTitle/MainTitle';
import CustomCheck from '../../../components/MonthlyServiceRequest/CustomCheck/CustomCheck';
import UbicationAccordion from '../../../components/MonthlyServiceRequest/CustomAccordion/UbicationAccordion';
import AddPLToUbicationModal from '../../../components/MonthlyServiceRequest/Modals/AddPLToUbicationModal/AddPLToUbicationModal';
import { MONTHS } from '../../../utils/formatUtils';
import NoWorkReports from '../../../components/WorkReports/NoWorkReports';
import HeaderTable from '../../../components/WorkReports/ViewOptionsContainer/DailyView/LineTableContainer/HeaderTable';
import LineRowTemplate from '../../../components/LineRowTemplate/LineRowTemplate';
import {
  mapperAllArray,
  mapperLineObject,
  mapperPositionObject,
  mapperBusinessUnit
} from '../../../utils/mapper';
import useToast from '../../../hooks/useToast';
import LoaderContext from '../../../context/LoaderProvider';
import {
  getDetailOfTemplate,
  putEditTemplate,
  changeTemplateType
} from '../../../services/templateWorkReport';
import useRequestDetailPermissions from '../../../hooks/useRequestDetailPermissions';
import ModalAddLocation from '../../../components/WorkReports/MonthlyWorkReport/ModalAddLocation/ModalAddLocation';
import NoUbications from '../../../components/MonthlyServiceRequest/NoData/NoUbications';
import {
  getTemplateAdapter,
  putUbicationTemplateAdapter
} from '../../../adapters/generateTemplate/ubicationsAdapter';
import DeleteUbicationModal from '../../../components/MonthlyServiceRequest/Modals/DeleteUbicationModal';
import useUbicationAccordion from '../../../hooks/useUbicationAccordion';
import ChangeTemplateTypeModal from '../../../components/MonthlyServiceRequest/Modals/ChangeTemplateTypeModal';
import useMultiplPositionAndLine from '../../../hooks/useMultiplePositionAndLine';
import AddMultiplePLModal from '../../../components/WorkReports/AddMultiplePLModal/AddMultiplePLModal';
import useGetParamsForWorkReportTemplate from '../../../hooks/useGetParamsForWorkReportTemplate';
import useLocationForWorkReportTemplate from '../../../hooks/useLocationForWorkReportTemplate/useLocationsForWorkReportTemplate';
import { getNroContractsOfUser } from '../../../services/adminContracts';

const EditTemplate = () => {
  const { isSDS } = useLocation();
  const history = useHistory();
  const { setNewToast } = useToast();
  const { idTemplate } = useParams();
  const { setLoader } = useContext(LoaderContext);
  const [positionLineValueProps, setPositionLineValueProps] = useState([]);
  const [isTemplateMonthly, setIsTemplateMonthly] = useState(true);
  const [inputTemplate, setInputTemplate] = useState('');
  const [idPlantilla, setIdPlantilla] = useState();
  const [nroContract, setNroContract] = useState({});
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showTemplateTypeModal, setShowTemplateTypeModal] = useState(false);
  const [deleteUbicationInfo, setDeleteUbicationInfo] = useState({ id: null, nombre: null });
  const [tipoNegocios, setTipoNegocios] = useState(null);
  const [showModalAddLine, setShowModalAddLine] = useState(false);
  const [gotData, setGotData] = useState(false);

  const today = Date.now();
  const year = new Date(today).getFullYear().toString();
  const monthNumber = new Date(today).getMonth() + 1;
  const month = MONTHS[monthNumber];
  const isEdit = history.location.pathname.includes('edit-template');

  const { permissions } = useRequestDetailPermissions({ notifyTo: 3 });
  const { paramsLocation, setBusinessUnitsAndOperationsAvailables } =
    useGetParamsForWorkReportTemplate({
      permissions
    });

  const workPartPermissions = permissions?.workPart;

  const {
    isAllAccordionsSelecteds,
    handleSelectAll,
    handleUnselectAll,
    accordionsSelecteds,
    changeSetAccordionsSelecteds,
    changeAddPLToUbicationState,
    handleOpenModalAddLocation,
    handleCloseModalAddLocation,
    modalAddLocation,
    closeAccordions,
    handleOpenAccordion,
    showAddPLToUbicationModal
  } = useUbicationAccordion({});

  const { positions } = useMultiplPositionAndLine({
    contractNumber: nroContract.id,
    isMonthly: isTemplateMonthly
  });

  const {
    locations,
    // TODO: hacer un handler dentro del custom hoock
    setLocations,
    setUbicationsAcc,
    handleDeleteUbication,
    handleUpdateLocationData,
    handleSubmitPosLines
  } = useLocationForWorkReportTemplate({ isEdit: true, accordionsSelecteds });

  const onClose = () => {
    setShowModalAddLine(false);
  };

  const areAllSelected = isAllAccordionsSelecteds(accordionsSelecteds, locations);

  const updateDeleteUbicationInfo = (idUbication, name) => {
    setDeleteUbicationInfo({ id: idUbication, nombre: name });
  };

  const handleSetPositionLineValueProps = (pLArray) => {
    const newPL = pLArray.map((pL) => ({
      ...pL,
      eliminarPosicionLinea: false,
      isNewPosLine: isEdit,
      amount: parseFloat(pL.amount)
    }));

    const posLineExists = positionLineValueProps.some((pL) =>
      pLArray.some(
        (posLine) =>
          posLine.position.numeroPosicion === pL.position.numeroPosicion &&
          posLine.line.numeroLinea === pL.line.numeroLinea
      )
    );
    const existentPosLineIndex = positionLineValueProps?.findIndex((pL) =>
      pLArray.some(
        (posLine) =>
          pL.position.numeroPosicion === posLine.position.numeroPosicion &&
          pL.line.numeroLinea === posLine.line.numeroLinea
      )
    );

    if (!posLineExists) {
      setNewToast({
        type: 'SUCCESS',
        message: 'Posición y línea agregada correctamente'
      });

      return setPositionLineValueProps((currentState) => currentState.concat(newPL));
    }
    if (positionLineValueProps[existentPosLineIndex].eliminarPosicionLinea) {
      setNewToast({
        type: 'SUCCESS',
        message: 'Posición y línea agregada correctamente'
      });
      const temporal = [...positionLineValueProps];

      temporal[existentPosLineIndex].eliminarPosicionLinea = false;

      return setPositionLineValueProps(temporal);
    }
    if (posLineExists) {
      setNewToast({
        type: 'ERROR',
        message: 'Ya existe la posicion y línea'
      });
    }

    return positionLineValueProps;
  };

  const handleChangeTemplateType = async () => {
    setLoader(true);
    setIsTemplateMonthly(!isTemplateMonthly);
    try {
      // TODO: Lo niego aca de nuevo porque no se manda actualizado
      await changeTemplateType(idTemplate, !isTemplateMonthly);
      setLocations([]);
      setPositionLineValueProps([]);
      setNewToast({
        type: 'SUCCESS',
        message: 'Ubicación eliminada correctamente'
      });
    } catch (error) {
      setNewToast({
        type: 'ERROR',
        message: error.message
      });
    } finally {
      setLoader(false);
    }
  };

  const updateBussinessUnitsAndOperations = async (numeroContrato) => {
    // Obtención de unidades de negocio segun contrato seleccionado
    try {
      const body = {
        unidadesNegocioIds: paramsLocation.optionsBusinessOptions?.map((uunn) => uunn.id),
        operacionesIds: paramsLocation?.optionsOperations?.map((op) => op.id) ?? []
      };
      const res = await getNroContractsOfUser(body);
      const contractsList = mapperBusinessUnit(res);
      const contractFound = contractsList.find((contract) => contract.id === numeroContrato);

      if (contractFound) {
        const operationIds = contractFound?.operationsIds?.length
          ? contractFound?.operationsIds
          : [];

        const businessUnitsIds = contractFound?.businessUnitsIds?.length
          ? contractFound?.businessUnitsIds
          : [];

        setBusinessUnitsAndOperationsAvailables({ businessUnitsIds, operationIds });
      }
    } catch (err) {
      setNewToast({
        type: 'ERROR',
        message: err.message
      });
    }
  };

  const fetchLinesPositionTemplate = useCallback(async () => {
    try {
      setLoader(true);
      const response = await getDetailOfTemplate(idTemplate);
      const {
        numeroContrato,
        nombrePlantilla,
        ubicaciones,
        idPlantillaParteTrabajo,
        plantillaParteTrabajoLineasSds,
        esMensualizada,
        tipoNegocio
      } = response;
      const adaptedLocations = getTemplateAdapter(ubicaciones);
      // Cuando traigo las ubicaciones, les pongo el flag de eliminar en false para posible edición
      const mappedLocations = adaptedLocations.map((loc) => ({
        ...loc,
        posLines: loc.posLines.map((pl) => ({ ...pl, eliminarPosicionLinea: false }))
      }));

      setIsTemplateMonthly(esMensualizada);
      setInputTemplate(nombrePlantilla);
      setIdPlantilla(idPlantillaParteTrabajo);
      setNroContract({
        id: numeroContrato,
        nombre: numeroContrato
      });
      setLocations(mappedLocations);
      setTipoNegocios(tipoNegocio);
      updateBussinessUnitsAndOperations(numeroContrato);
      plantillaParteTrabajoLineasSds?.map((value2) => {
        setPositionLineValueProps((prevState) => [
          ...prevState,
          {
            idPlantillaParteTrabajoLinea: value2.idPlantillaParteTrabajoLinea,
            position: mapperPositionObject(value2),
            line: mapperLineObject(value2),
            amount: value2.cantidad || null,
            // Las inicializo con flag de eliminación en false
            eliminarPosicionLinea: false
          }
        ]);

        return null;
      });
      setLoader(false);
    } catch (err) {
      setLoader(false);
      setNewToast({
        type: 'ERROR',
        message: err.message
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [idTemplate, setLoader, setNewToast, setBusinessUnitsAndOperationsAvailables]);

  const nombre = 'Editar plantilla de parte de trabajo';
  const nameFotterButton = 'Guardar Cambios ';
  const urlTemplateWR = '/manage-temp/workReport';
  const showAddPLtoUbicationButton = !!locations?.length && isTemplateMonthly;

  const onClickFunction = async () => {
    // eslint-disable-next-line no-unused-vars
    const temporal = {
      idPlantillaParteTrabajo: idPlantilla,
      numeroContrato: nroContract.id,
      nombrePlantilla: inputTemplate,
      esMensualizada: isTemplateMonthly,
      tipoNegocio: tipoNegocios,
      ubicaciones: putUbicationTemplateAdapter(locations),
      plantillaParteTrabajoLineaSds: isTemplateMonthly
        ? null
        : mapperAllArray(
            positionLineValueProps.map((pL) => ({
              ...pL,
              idPlantillaParteTrabajoLinea: pL.isNewPosLine ? null : pL.idPlantillaParteTrabajoLinea
            }))
          )
    };

    try {
      setLoader(true);
      const response = await putEditTemplate(idPlantilla, temporal);

      setNewToast({
        type: 'SUCCESS',
        message: response.mensaje
      });
      setLoader(false);
      if (isSDS) history.push(isSDS?.pathname);
      else history.push(urlTemplateWR);
    } catch (err) {
      setLoader(false);
      setNewToast({
        type: 'ERROR',
        message: err.message
      });
    }
  };

  const onClickExit = () => {
    if (isSDS) history.push(isSDS?.pathname);
    else history.push(urlTemplateWR);
  };

  const initialValues = {};
  const form = useRef();

  const handleClick = ({ position, line }) => {
    const { idPosicion } = position;
    const { idLinea } = line;
    const positionLineTemporal = structuredClone(positionLineValueProps);

    // Actualizo flag para enviar a BE
    positionLineTemporal.find(
      (data) => data.position.idPosicion === idPosicion && data.line.idLinea === idLinea
    ).eliminarPosicionLinea = true;

    setPositionLineValueProps(positionLineTemporal);
  };

  const handleOnChangeName = (e) => {
    setInputTemplate(e.target.value);
  };

  useEffect(() => {
    if (
      !paramsLocation.disabledChangeUunn &&
      (paramsLocation?.optionsBusinessOptions?.length > 0 ||
        paramsLocation?.optionsOperations?.length > 0) &&
      !gotData
    ) {
      setGotData(true); // el mismo fetch modifica paramsLocation, esto evita que se duplique data
      fetchLinesPositionTemplate();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [paramsLocation]);

  return (
    <>
      <div className="container">
        <MainTitle isSDS={isSDS} nombre={nombre} previusPath={urlTemplateWR} />
        <div className="my-4">
          <ContentCard orientation="vertical-horizontal">
            <div className="d-flex align-items-center" style={{ gap: '5px' }}>
              <Col>
                <Label icon="" label="Nombre de la plantilla" size="md" sizeValue="md" value="" />
                <Input
                  className="w-100 mb-4"
                  name="Input"
                  onChange={handleOnChangeName}
                  placeholder="Ingrese el nombre para la plantilla"
                  type="text"
                  value={inputTemplate}
                />
              </Col>
              <div className="text-center">
                <Switch
                  checked={isTemplateMonthly}
                  className="pt-2 px-2 SwitchAccordion"
                  color="primary-secondary"
                  labelPlacement="bottom"
                  name="Mensualizada"
                  onChange={() => setShowTemplateTypeModal(true)}
                  size="sm"
                  sizeLabel="sm"
                  title="Mensualizada"
                />
              </div>
            </div>
            <Label className="mb-4" icon="" label="Contrato" size="md" sizeValue="md" value="" />
            <div className="d-flex justify-content-between ">
              <SelectGeneric isDisabled options={[nroContract]} />
              {showAddPLtoUbicationButton && (
                <div className="d-flex justify-content-between align-items-center w-90">
                  <div className="d-flex">
                    <CustomCheck
                      isChecked={areAllSelected}
                      onChange={() => {
                        if (areAllSelected) {
                          handleUnselectAll();
                        } else {
                          handleSelectAll(locations);
                        }
                      }}
                    />
                    <Button
                      className="mx-2"
                      colorIcon="primary"
                      disabled={accordionsSelecteds.length === 0}
                      icon={AiOutlinePlusCircle}
                      iconRight
                      label="Agregar posición y línea a ubicaciones"
                      onClick={() => changeAddPLToUbicationState(true)}
                      sizeIcon="17px"
                      type="button"
                      variant="light-gray"
                      widthButton="300px"
                    />
                  </div>
                </div>
              )}
              {!isTemplateMonthly ? (
                <Button
                  colorIcon="primary"
                  disabled={false}
                  fontSizeLabel="15px"
                  icon={AiOutlinePlusCircle}
                  iconRight
                  label="Agregar líneas al parte"
                  onClick={() => setShowModalAddLine(true)}
                  sizeIcon="17px"
                  type="button"
                  variant="light-gray"
                  widthButton="200px"
                />
              ) : (
                <Button
                  colorIcon="primary"
                  disabled={false}
                  fontSizeLabel="15px"
                  icon={AiOutlinePlusCircle}
                  iconRight
                  label="Agregar ubicación"
                  onClick={() => handleOpenModalAddLocation()}
                  sizeIcon="17px"
                  type="button"
                  variant="light-gray"
                  widthButton="200px"
                />
              )}
            </div>

            <hr />
            {!isTemplateMonthly &&
              (positionLineValueProps?.length &&
              !positionLineValueProps?.every((data) => data.eliminarPosicionLinea) ? (
                <ul className="list_container">
                  <HeaderTable tableTemplate />
                  <Formik initialValues={initialValues} innerRef={form}>
                    {() => (
                      <Form>
                        {positionLineValueProps?.map((data, index) =>
                          data.eliminarPosicionLinea ? null : (
                            <li
                              // eslint-disable-next-line react/no-array-index-key
                              key={index}
                            >
                              <LineRowTemplate
                                amount={data.amount}
                                editComponent
                                handleClick={() => handleClick(data)}
                                line={data?.line}
                                position={data?.position}
                              />
                            </li>
                          )
                        )}
                      </Form>
                    )}
                  </Formik>
                </ul>
              ) : (
                <NoWorkReports
                  subtitle="Agregá las posiciones y líneas para generar las plantillas"
                  title="No disponés de ninguna posición y línea"
                />
              ))}
            {isTemplateMonthly && (
              <div className="location-workreports-container">
                {locations?.length &&
                !locations.every((ubication) => ubication.eliminarUbicacion) ? (
                  <>
                    {locations && (
                      <>
                        {locations?.map((ubication, ubicationIndex) =>
                          ubication.eliminarUbicacion ? null : (
                            <UbicationAccordion
                              IOPermissions
                              accordionData={ubication}
                              accordionsSelecteds={accordionsSelecteds}
                              asignationType={3}
                              byUbication
                              closeAccordions={closeAccordions}
                              disabledEditStateCancelOrFinish={false}
                              handleOpenAccordion={handleOpenAccordion}
                              handleUpdateLocationData={handleUpdateLocationData}
                              hasPositionLines={ubication.tienePosicionLinea}
                              isTemplate
                              key={ubication.id}
                              month={month}
                              newLineAdded
                              setAccordionsSelecteds={changeSetAccordionsSelecteds}
                              setShowAddPLToUbicationModal={changeAddPLToUbicationState}
                              setShowDeleteModal={setShowDeleteModal}
                              ubicationIndex={ubicationIndex}
                              updateDeleteUbicationInfo={updateDeleteUbicationInfo}
                              workPartPermissions={workPartPermissions}
                              year={year}
                            />
                          )
                        )}
                        <AddPLToUbicationModal
                          contractNumber={nroContract.id}
                          isTemplate
                          month={month}
                          onSubmit={handleSubmitPosLines}
                          setShowAddPLToUbicationModal={changeAddPLToUbicationState}
                          showAddPLToUbicationModal={showAddPLToUbicationModal}
                          ubicationsSelecteds={locations.filter(
                            (ubication) =>
                              accordionsSelecteds.includes(ubication.id) &&
                              !ubication.eliminarUbicacion
                          )}
                          year={year}
                        />
                      </>
                    )}
                  </>
                ) : (
                  <NoUbications />
                )}
              </div>
            )}
          </ContentCard>
        </div>
        <FooterButtonTemplate
          name={nameFotterButton}
          onClickExit={onClickExit}
          onClickFunction={onClickFunction}
        />
      </div>
      <AddMultiplePLModal
        contractNumber={nroContract.id}
        onCloseModal={onClose}
        onSubmitPL={(values) => handleSetPositionLineValueProps(values)}
        positions={positions}
        showModal={showModalAddLine}
      />
      <ModalAddLocation
        canAddWellToImputationObject
        canEditImputationObject
        handleSubmit={setUbicationsAcc}
        isTemplate
        notFilterTypeOptions={false}
        onClose={handleCloseModalAddLocation}
        params={paramsLocation}
        show={modalAddLocation.show}
      />
      <DeleteUbicationModal
        handleDeleteUbication={handleDeleteUbication}
        setShowDeleteModal={setShowDeleteModal}
        showDeleteModal={showDeleteModal}
        ubicationId={deleteUbicationInfo.id}
        ubicationName={deleteUbicationInfo.nombre}
      />
      <ChangeTemplateTypeModal
        handleChangeTemplateType={handleChangeTemplateType}
        handleShowChangeTemplateTypeModal={setShowTemplateTypeModal}
        idPlantilla={idPlantilla}
        showChangeTemplateTypeModal={showTemplateTypeModal}
      />
    </>
  );
};

export default EditTemplate;
